// Shared constants for Social Circle
export const TOKEN_KEY = 'social_circle_token';
export const USER_KEY = 'social_circle_user';
